import { timelineMetricId } from '../constants';

export function isTimelineMetric(metricID: number) {
  return metricID === timelineMetricId;
}
